/**
 * TanStack Query hooks for `ml-based-invalid-traffic-ivt-engine`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	mlBasedInvalidTrafficIvtEngineQueryKeys,
	type CreateMlBasedInvalidTrafficIvtEngineBody,
	type ListMlBasedInvalidTrafficIvtEngineResponse,
	type MlBasedInvalidTrafficIvtEngineRow,
} from "./api";

export function useMlBasedInvalidTrafficIvtEngineList(): UseQueryResult<ListMlBasedInvalidTrafficIvtEngineResponse, Error> {
	return useQuery({
		queryKey: mlBasedInvalidTrafficIvtEngineQueryKeys.list(),
		queryFn: list,
	});
}

export function useMlBasedInvalidTrafficIvtEngineCreate(): UseMutationResult<MlBasedInvalidTrafficIvtEngineRow, Error, CreateMlBasedInvalidTrafficIvtEngineBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: mlBasedInvalidTrafficIvtEngineQueryKeys.all });
		},
	});
}

export function useMlBasedInvalidTrafficIvtEngineDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: mlBasedInvalidTrafficIvtEngineQueryKeys.all });
		},
	});
}
